/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CardType,
    CardTypeFromJSON,
    CardTypeFromJSONTyped,
    CardTypeToJSON,
} from './CardType';
import {
    CarePrincipalInfo,
    CarePrincipalInfoFromJSON,
    CarePrincipalInfoFromJSONTyped,
    CarePrincipalInfoToJSON,
} from './CarePrincipalInfo';
import {
    Person,
    PersonFromJSON,
    PersonFromJSONTyped,
    PersonToJSON,
} from './Person';

/**
 * 
 * @export
 * @interface Card
 */
export interface Card {
    /**
     * 
     * @type {Date}
     * @memberof Card
     */
    preliminaryCardDate?: Date;
    /**
     * 
     * @type {CardType}
     * @memberof Card
     */
    cardType?: CardType;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    cardId?: string;
    /**
     * 
     * @type {Array<Person>}
     * @memberof Card
     */
    persons?: Array<Person>;
    /**
     * 
     * @type {Date}
     * @memberof Card
     */
    finalCardDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    registeringCareProviderId?: string;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    status?: CardStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof Card
     */
    currentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof Card
     */
    amountToLimit?: number;
    /**
     * 
     * @type {CarePrincipalInfo}
     * @memberof Card
     */
    carePrincipal?: CarePrincipalInfo;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    cardSystemId?: string;
    /**
     * 
     * @type {Date}
     * @memberof Card
     */
    endDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Card
     */
    startDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Card
     */
    cardReason?: CardCardReasonEnum;
}

/**
* @export
* @enum {string}
*/
export enum CardStatusEnum {
    Belowlimit = 'BELOWLIMIT',
    Preliminary = 'PRELIMINARY',
    Final = 'FINAL',
    Expired = 'EXPIRED'
}/**
* @export
* @enum {string}
*/
export enum CardCardReasonEnum {
    Validcard = 'VALIDCARD',
    Medical = 'MEDICAL'
}

export function CardFromJSON(json: any): Card {
    return CardFromJSONTyped(json, false);
}

export function CardFromJSONTyped(json: any, ignoreDiscriminator: boolean): Card {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'preliminaryCardDate': !exists(json, 'preliminaryCardDate') ? undefined : (new Date(json['preliminaryCardDate'])),
        'cardType': !exists(json, 'cardType') ? undefined : CardTypeFromJSON(json['cardType']),
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'persons': !exists(json, 'persons') ? undefined : ((json['persons'] as Array<any>).map(PersonFromJSON)),
        'finalCardDate': !exists(json, 'finalCardDate') ? undefined : (new Date(json['finalCardDate'])),
        'registeringCareProviderId': !exists(json, 'registeringCareProviderId') ? undefined : json['registeringCareProviderId'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'currentAmount': !exists(json, 'currentAmount') ? undefined : json['currentAmount'],
        'amountToLimit': !exists(json, 'amountToLimit') ? undefined : json['amountToLimit'],
        'carePrincipal': !exists(json, 'carePrincipal') ? undefined : CarePrincipalInfoFromJSON(json['carePrincipal']),
        'cardSystemId': !exists(json, 'cardSystemId') ? undefined : json['cardSystemId'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'cardReason': !exists(json, 'cardReason') ? undefined : json['cardReason'],
    };
}

export function CardToJSON(value?: Card | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'preliminaryCardDate': value.preliminaryCardDate === undefined ? undefined : (value.preliminaryCardDate.toISOString().substr(0,10)),
        'cardType': CardTypeToJSON(value.cardType),
        'cardId': value.cardId,
        'persons': value.persons === undefined ? undefined : ((value.persons as Array<any>).map(PersonToJSON)),
        'finalCardDate': value.finalCardDate === undefined ? undefined : (value.finalCardDate.toISOString().substr(0,10)),
        'registeringCareProviderId': value.registeringCareProviderId,
        'status': value.status,
        'currentAmount': value.currentAmount,
        'amountToLimit': value.amountToLimit,
        'carePrincipal': CarePrincipalInfoToJSON(value.carePrincipal),
        'cardSystemId': value.cardSystemId,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString().substr(0,10)),
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString().substr(0,10)),
        'cardReason': value.cardReason,
    };
}

